import {

  reqPassResetRequest,
  reqPassResetResponse,
    resetPasswordRequest,
    signInRequest,
    signInResponse,
    signUpRequest,
    signUpResponse,
  } from '../../../shared';
  import {ENDPOINT_CONFIGS}  from '../endpoints';
  
  import { callEndpoint } from '.';

  

  export const LOCAL_STORAGE_JWT = 'jwtToken';
  export const LOCAL_STORAGE_EMAIL = 'useremail';
  export const LOCAL_STORAGE_KIND = 'userkind';
  export const LOCAL_STORAGE_Id = 'userid';
  export const LOCAL_STORAGE_ADDRESS = 'useraddress'; 
  export const LOCAL_STORAGE_PHONE = 'userphone'; 
  export const LOCAL_STORAGE_NAME = 'username'; 

  export const getLocalStorageJWT = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_JWT) || '';
  };

  export const getLocalStorageEMIAL = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_EMAIL) || '';
  };

  export const getLocalStorageKIND = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_KIND) || '';
  };
  
  export const getLocalStorageID = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_Id) || '';
  };

  export const getLocalStorageADDRESS = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_ADDRESS) || '';
  };

  export const getLocalStoragePHONE = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_PHONE) || '';
  };

  export const getLocalStorageNAME= (): string => {
    return localStorage.getItem(LOCAL_STORAGE_NAME) || '';
  };

  export const isLoggedIn = (): boolean => {
   
    const jwt = getLocalStorageJWT();
    return !!jwt;
  };

  export const isAdmin = (): boolean => {
  
    const kind = getLocalStorageKIND();

    return kind==='admin';
  };
  
  export const isCaptin = (): boolean => {
   
    const kind = getLocalStorageKIND();
    return kind==='captin';
  };
  export const signIn = async (email: string, password: string) => {
  
    const res = await callEndpoint<signInRequest, signInResponse>(ENDPOINT_CONFIGS.signin, {
      email,
      password,
    });
 
    localStorage.setItem(LOCAL_STORAGE_JWT, res.jwt);
    localStorage.setItem(LOCAL_STORAGE_EMAIL,res.user.email);
    localStorage.setItem(LOCAL_STORAGE_KIND,res.user.kind);
    localStorage.setItem(LOCAL_STORAGE_Id,res.user.id);
    localStorage.setItem(LOCAL_STORAGE_ADDRESS,res.user.address);
    localStorage.setItem(LOCAL_STORAGE_PHONE,res.user.phone);
    localStorage.setItem(LOCAL_STORAGE_PHONE,res.user.name);
  };
  
export const onUpdateUserProfile = (name:string, phone:string, address:string)=>{
  localStorage.setItem(LOCAL_STORAGE_ADDRESS,address);
  localStorage.setItem(LOCAL_STORAGE_PHONE, phone);
  localStorage.setItem(LOCAL_STORAGE_NAME, name);
};

  export const requestPassReset = async (email: string, url:string) => {
  
   await callEndpoint<reqPassResetRequest, reqPassResetResponse>(ENDPOINT_CONFIGS.reqResetpass, {
      email,
      url,
    });
  };

  export const resetPassword = async (password:string, token:string) => {
  
    await callEndpoint<resetPasswordRequest, reqPassResetResponse>(ENDPOINT_CONFIGS.resetpass, {
       password,
       token
     });
   };

  export const signUp = async (
    email: string,
    name: string,
    address: string,
    password: string,
    phone: string
  ) => {
    const res = await callEndpoint<signUpRequest, signUpResponse>(ENDPOINT_CONFIGS.signup, {
      email,
      name,
      address,
      password,
      phone,
    });
    localStorage.setItem(LOCAL_STORAGE_JWT, res.jwt);
    storeUserLocally(res.userId,email,'client',address,phone,name);
    
  };
  
  export const storeUserLocally = (id:string,email:string,kind:string,address:string, phone:string, name:string)=>{
    localStorage.setItem(LOCAL_STORAGE_Id,id);
    localStorage.setItem(LOCAL_STORAGE_EMAIL,email);
    localStorage.setItem(LOCAL_STORAGE_KIND,kind);
    localStorage.setItem(LOCAL_STORAGE_ADDRESS,address);
    localStorage.setItem(LOCAL_STORAGE_PHONE,phone);
    localStorage.setItem(LOCAL_STORAGE_PHONE,name);
  }
  export const signOut = () => {

    localStorage.removeItem(LOCAL_STORAGE_JWT);
    localStorage.removeItem(LOCAL_STORAGE_EMAIL);
    localStorage.removeItem(LOCAL_STORAGE_Id);
    localStorage.removeItem(LOCAL_STORAGE_KIND);
    localStorage.removeItem(LOCAL_STORAGE_ADDRESS);
    localStorage.removeItem(LOCAL_STORAGE_PHONE);
    localStorage.removeItem(LOCAL_STORAGE_NAME);
  };